import SearchPopover from "./SearchPopover"

export default SearchPopover
